import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { FavoriteNonStandardMedicineResponse } from '../../responses/medic/favorite-non-standard-medicine.response';

@Injectable({
  providedIn: 'root'
})
export class FavoriteNonStandardMedicineService extends CommonService {

  constructor(private httpClient: HttpClient) { super(); }

  public getFavoriteNonStandardMedicine(idFavoriteNonStandardPrescription: number): Observable<FavoriteNonStandardMedicineResponse> {
    let uri = `FavoriteNonStandardMedicine/idMedicFavoriteNonStandardPrescription/${idFavoriteNonStandardPrescription}`

    return this.httpClient.get<FavoriteNonStandardMedicineResponse>(environment.urlApiMedic + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}